export default __webpack_public_path__ + "780ddff4fa29b7843aefb1f499bdbc49.png";